import React, { useState } from 'react';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import {
    ButtonsContainer,
    StyledDiv,
    TabContainer,
    TextArea,
    TextAreaContainer,
    Title,
} from './BulkAdd.styled';
import { useTranslation } from 'react-i18next';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import { useDispatch, useSelector } from 'react-redux';
import {
    SET_ITEMS_DURING_PRICING,
    SET_REMOVE_APPLIED_SIGNATURE,
} from 'src/pages/reportUsage/redux/action/types';
import {
    getPricesForItems,
    setAllAccountOwned,
    resetProgressBarStatus,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { generate_UUID, isIpad, isMobileView, logErrorToConsole } from 'src/utils/util';
import {
    emptyBundleMsg,
    getNewItemObj,
    getUniqueKey,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';

const BulkAdd = ({
    filteredProduct,
    setFilteredProduct,
    isBundle = false,
    selectedBundleProduct,
    setDisableDoneButton,
    isReportPayment,
    setSuccesMesssage,
    setBundleError = () => {},
    reportPaymentGridData,
    setReportPaymentGridData,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
        myCaseRefId,
        myCaseRefIdObj,
        usageDetails,
        signatureImg,
        dateOfSignature,
        itemsWhenSignatureApplied,
        // reportPaymentGridData,
        myCaseResourceType,
    } = useSelector((state) => ({
        myCaseRefId: state.reportUsageRootReducer.myCaseRefId,
        usageDetails: state.reportUsageRootReducer.usageDetails,
        signatureImg:
            state.reportUsageRootReducer.localSignatureDetails.base64Image,
        dateOfSignature:
            state.reportUsageRootReducer.localSignatureDetails.dateOfSignature,
        itemsWhenSignatureApplied:
            state.reportUsageRootReducer.signatureItemState,
        reportPaymentGridData:
            state.reportUsageRootReducer.usagePersistData.reportPayment,
        myCaseResourceType: state.reportUsageRootReducer.myCaseResourceType,
        myCaseRefIdObj:
            state.reportUsageRootReducer.reportUsageObject.myCaseRef,
    }));
    const bundleHeadersArr =
        usageDetails?.bundleHeaders && usageDetails?.bundleHeaders.split(',');

    const [bulkValues, setBulkValues] = useState('');
    const [editableHeight, setEditableHeight] = useState('');
    const [popupDetails, setPopupDetails] = useState({
        showDiscardPopup: false,
        id: null,
    });
    const { showDiscardPopup } = popupDetails;

    const onBulkAddChange = (value) => {
        setBulkValues(value);
        if (value.length > 0) {
            setSuccesMesssage(false);
            setBundleError(false);
        }
    };
    const onClearButtonClick = (id) => {
        if (bulkValues.length > 0) {
            setPopupDetails({
                ...popupDetails,
                showDiscardPopup: true,
                id: id,
            });
        } else {
            setBundleError(false);
            setSuccesMesssage(false);
        }
    };

    const resetPosition = () => {
        setEditableHeight('');
        setTimeout(() => {
            try {
            if (isMobileView() || isIpad()) {
                document.getElementById('popUpContent').style.position = '';
                document.getElementById('popUpContent').style.top = '';
            }
              } catch (error) {
                logErrorToConsole(error);
            }
        }, 0);
    };

    const handleDiscardChanges = () => {
        setPopupDetails({ ...popupDetails, showDiscardPopup: false, id: null });
        //clearing the data
        setBulkValues('');
        resetPosition();
    };

    // this method extracts the text from clipboard and sets the text to text area
    const copyToClipBoard = () => {
        navigator.clipboard
            .readText()
            .then((result) => {
                const finalResult = bulkValues.length
                    ? `${bulkValues}\n ${result}`
                    : result;
                setBulkValues(finalResult);
            })
            .catch((error) => {
                logErrorToConsole('something went wrong', error);
            });
    };

    const removeAppliedSignature = () => {
        if (
            itemsWhenSignatureApplied?.length > 0 &&
            signatureImg?.length > 0 &&
            dateOfSignature?.length > 0
        ) {
            dispatch({ type: SET_REMOVE_APPLIED_SIGNATURE, payload: true });
        }
    };

    const checkIfValidBundleItem = (itemId) => {
        if (itemId && bundleHeadersArr && bundleHeadersArr.length > 0) {
            const itemCFN = itemId.toUpperCase();
            return bundleHeadersArr.includes(itemCFN);
        }
        return false;
    };

    const checkS33ItemPresent = (itemList) => {
        const s33Item = itemList.filter((item) =>
            item.cfn.toUpperCase().startsWith('S33')
        );
        return s33Item.length > 0;
    };

    const showErrorMsg = (msg, removeMsg) => {
        setSuccesMesssage({
            show: true,
            message: msg,
        });
        isBundle &&
            removeMsg &&
            setTimeout(() => setSuccesMesssage(false), 2000);
    };

    const priceItems = (tableData) => {
        if (tableData.length > 0 && myCaseRefId) {
            const bundleItems = tableData.filter(
                (item) =>
                    item.isBundleItem &&
                    !(
                        (item.cfn || item.productCFN)
                            .toUpperCase()
                            .startsWith('M1') &&
                        bundleHeadersArr?.includes(item.cfn || item.productCFN)
                    )
            );
            if (
                !isReportPayment &&
                bundleItems?.length > 0 &&
                !bundleItems.every(
                    (bItem) => bItem.children && bItem.children.length > 0
                )
            ) {
                // setIsButtonDisabled(true);
                // isReportPayment && setIsRPButtonDisabled(false);
                const updatedTableData = tableData.map((item) => ({
                    ...item,
                    noItemInBundleErr: item.isBundleItem
                        ? (!item.children ||
                              (item.children && item.children.length === 0)) &&
                          emptyBundleMsg()
                        : null,
                }));
                setFilteredProduct(updatedTableData);
            } else if (
                myCaseResourceType === 'reportPayment' &&
                bundleItems?.length > 0 &&
                !bundleItems.every(
                    (bItem) => bItem.bundleItem && bItem.bundleItem.length > 0
                )
            ) {
                // setIsButtonDisabled(true);
                // isReportPayment && setIsRPButtonDisabled(false);
                const updatedTableData = tableData.map((item) => ({
                    ...item,
                    noItemInBundleErr: item.isBundleItem
                        ? (!item.bundleItem ||
                              (item.bundleItem &&
                                  item.bundleItem.length === 0)) &&
                          emptyBundleMsg()
                        : null,
                }));
                setReportPaymentGridData(updatedTableData);
            }
            const validReportUsageItems = tableData.filter(
                (item) =>
                    !(
                        (item.cfn || item.productCFN)
                            .toUpperCase()
                            .startsWith('M1') &&
                        bundleHeadersArr?.includes(item.cfn || item.productCFN)
                    )
            );
            const bundleItemsInList = (tableData && Array.isArray(tableData)) 
                ? tableData.filter(
                    (item) => item.children && item.children.length > 0
                )
                : [];
            const bundleChildItems = isReportPayment
                ? (tableData && Array.isArray(tableData)) && tableData.filter((item) => item.bundleItem?.length > 0)
                      ?.length > 0
                    ? tableData
                          .filter((item) => item.bundleItem?.length > 0)
                          .reduce(
                              (prev, curr) => prev.concat(curr.bundleItem),
                              []
                          )
                    : []
                : bundleItemsInList &&
                  bundleItemsInList.reduce((previousValue, currentValue) => {
                      const childItems = currentValue.children.filter(
                          (child) =>
                              !bundleHeadersArr?.includes(
                                  (child.cfn || child.productCFN).toUpperCase()
                              )
                      );
                      return previousValue.concat(childItems);
                  }, []);
            const itemsToBePriced =
                bundleChildItems && bundleChildItems.length > 0
                    ? validReportUsageItems.concat(bundleChildItems)
                    : validReportUsageItems;
            const priceItemsObj = {
                productCFN: itemsToBePriced
                    .map((item) => item.cfn || item.productCFN)
                    .toString(),
                sapPartnerId: usageDetails.accountId,
                sstref:
                    myCaseRefId || myCaseRefIdObj || usageDetails?.myCaseRef,
            };
            if (usageDetails.territoryId) {
                priceItemsObj.territoryId = usageDetails.territoryId;
            }
            if (usageDetails.changeAccountEnabled) {
                priceItemsObj.isChangeAccount = true;
            }
            dispatch({
                type: SET_ITEMS_DURING_PRICING,
                payload: itemsToBePriced.map((item) =>
                    isReportPayment ? item.productCFN : item.cfn
                ),
            });
            dispatch(getPricesForItems(priceItemsObj));
        }
    };

    const addItemsToList = (setOrItemNumbersFinal, newProduct) => {
        let isS33ItemPresent = checkS33ItemPresent(newProduct);
        let showMultipleS33ItemErrorMsg = false;
        let countOfItemsRemoved = 0;
        setOrItemNumbersFinal.map((itemCFN) => {
            const addedProduct = {
                value: itemCFN,
                isBundle: checkIfValidBundleItem(itemCFN),
                isSet: false,
            };
            if (itemCFN.toUpperCase().startsWith('S33')) {
                if (isS33ItemPresent) {
                    showMultipleS33ItemErrorMsg = true;
                    countOfItemsRemoved++;
                    return;
                }
                isS33ItemPresent = true;
            }
            if (addedProduct?.value && Object.keys(addedProduct).length > 0) {
                const newlyAddedItem = getNewItemObj(
                    addedProduct,
                    {},
                    true,
                    bundleHeadersArr,
                    false

                );
                if (
                    usageDetails &&
                    usageDetails.products &&
                    usageDetails.products.find(
                        (item) =>
                            item.isUnidRodItem &&
                            item.productCFN.toLowerCase() ===
                                addedProduct.value.toLowerCase()
                    )
                ) {
                    newlyAddedItem.isUnidRodItem = true;
                }
                newProduct.push(newlyAddedItem);
            }
        });
        if (showMultipleS33ItemErrorMsg) {
            showErrorMsg(
                t('reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound')
            );
        }
        if (setOrItemNumbersFinal.length - countOfItemsRemoved > 0) {
            setFilteredProduct(newProduct);
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            priceItems(newProduct);
        }
    };

    const addItemsToRPList = (setOrItemNumbersFinal, newProduct) => {
        let tempNewProduct = [...newProduct];
        let isS33ItemPresent = checkS33ItemPresent(newProduct);
        let showMultipleS33ItemErrorMsg = false;
        let showBundleItemErrorMsg = false;
        let countOfItemsRemoved = 0;
        setOrItemNumbersFinal.map((itemCFN) => {
            const addedProduct = {
                value: itemCFN,
                isBundle: checkIfValidBundleItem(itemCFN),
                isSet: false,
            };
            if (itemCFN.toUpperCase().startsWith('S33')) {
                if (isS33ItemPresent) {
                    showMultipleS33ItemErrorMsg = true;
                    countOfItemsRemoved++;
                    return;
                }
                isS33ItemPresent = true;
            }
            if (myCaseResourceType === 'reportUsage' && addedProduct.isBundle) {
                showBundleItemErrorMsg = true;
                countOfItemsRemoved++;
                return;
            }
            const newlyAddedItem = getNewItemObj(
                addedProduct,
                {},
                true,
                bundleHeadersArr,
                false,
                myCaseResourceType

            );
            if (addedProduct.isBundle) {
                newlyAddedItem.isBundleFromAddItem = true;
                newlyAddedItem.bundleItem = [];
                newlyAddedItem.isBundleItem = addedProduct.isBundle;
                newlyAddedItem.bundleHeaderPosition =
                    newProduct.filter(
                        (data) =>
                            data.cfn.toUpperCase().startsWith('M2') ||
                            data.cfn.toUpperCase().startsWith('BUN') ||
                            data.cfn.toUpperCase().startsWith('KEN') ||
                            data.cfn.toUpperCase().startsWith('M1')
                    ).length > 0
                        ? newProduct.filter(
                              (data) =>
                                  data.cfn.toUpperCase().startsWith('M2') ||
                                  data.cfn.toUpperCase().startsWith('BUN') ||
                                  data.cfn.toUpperCase().startsWith('KEN') ||
                                  data.cfn.toUpperCase().startsWith('M1')
                          ).length
                        : 0;
            }
            newlyAddedItem.unqId = `${getUniqueKey()} ${addedProduct.value}`;
            newlyAddedItem.productCFN = addedProduct.value;
            newProduct.push(newlyAddedItem);

            const newObject = {
                basePrice: newlyAddedItem.basePrice,
                id: generate_UUID(),
                unqId: generate_UUID(),
                description: newlyAddedItem.description,
                extPrice: newlyAddedItem.extPrice,
                isAccountOwned: newlyAddedItem.accountOwned,
                isAdditionalCartEntry: newlyAddedItem.isAdditionalCartEntry,
                isReplenish: newlyAddedItem.isReplenish,
                productCFN: newlyAddedItem.cfn,
                cfn: newlyAddedItem.cfn,
                salesOrg: newlyAddedItem.salesOrg,
                uom: newlyAddedItem.uom,
                unitPrice: newlyAddedItem.unitPrice,
                usedQuantity: newlyAddedItem?.bundleItem
                    ? newlyAddedItem.usedQuantity
                        ? newlyAddedItem.usedQuantity
                        : 1
                    : newlyAddedItem.usedQuantity,
                lotSerialNumber: newlyAddedItem.lotSerialNumber,
                //  usedQtyExtPrice: newlyAddedItem.usedQtyExtPrice,
                usedQtyExtPrice: newlyAddedItem.usedQtyExtPrice,
                isBundleFromAddItem: newlyAddedItem?.isBundleFromAddItem,
                bundleItem: newlyAddedItem?.bundleItem,
                isBundleItem: newlyAddedItem?.isBundleItem,
                bundleHeaderPosition: newlyAddedItem?.bundleHeaderPosition,
                isPriced: false,
                // otherQtyExtPrice: newlyAddedItem.otherQtyExtPrice,
            };

            const chekgriddata = [
                ...tempNewProduct,
                {
                    ...newObject,
                    isAdditionalCartEntry: true,
                },
            ];
            tempNewProduct = [...chekgriddata];
        });

        if (showMultipleS33ItemErrorMsg) {
            showErrorMsg(
                t('reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound')
            );
        }
        if (showBundleItemErrorMsg) {
            setBundleError(true);
        }
        if (setOrItemNumbersFinal.length - countOfItemsRemoved > 0) {
            setFilteredProduct(newProduct);
            setReportPaymentGridData(tempNewProduct);
            priceItems(tempNewProduct);
        }
    };

    const addItemsToBundle = (setOrItemNumbersFinal, newProduct) => {
        let filteredList = [];
        let filteredProductList = [];
        let selectedParentIndex = selectedBundleProduct.index;
        let selectedParentItem = selectedBundleProduct.cfn;
        filteredList = newProduct?.filter(
            (item) => item.cfn === selectedParentItem
        );
        let isS33ItemPresent = checkS33ItemPresent(
            newProduct[selectedParentIndex].children
        );
        let showMultipleS33ItemErrorMsg = false;
        let countOfItemsRemoved = 0;

        setOrItemNumbersFinal.map((itemCFN) => {
            const addedChildProduct = {
                parent: selectedBundleProduct,
                child: itemCFN,
                isBundle: checkIfValidBundleItem(itemCFN),
                isSet: false,
            };

            if (itemCFN.toUpperCase().startsWith('S33')) {
                if (isS33ItemPresent) {
                    showMultipleS33ItemErrorMsg = true;
                    countOfItemsRemoved++;
                    return;
                }
                isS33ItemPresent = true;
            }
            if (
                addedChildProduct?.child &&
                Object.keys(addedChildProduct).length > 0 &&
                filteredList
            ) {
                const newlyAddedChildItem = {
                    cfn: addedChildProduct?.child,
                    dailyRate: '',
                    description: '',
                    salesOrg: '',
                    uom: '',
                    accountOwned: false,
                    lotSerial: [{ used: false, id: getUniqueKey() }],
                    isBundleFromAddItem: addedChildProduct.isBundle,
                    isSet: addedChildProduct.isSet,
                };

                if (addedChildProduct.isBundle) {
                    newlyAddedChildItem.isBundleItem = true;
                    newlyAddedChildItem.isInvalidItemMsg = t(
                        'productValidationMessages.bundleCannotBeAddedAsItemMsg'
                    );
                }

                if (!newProduct[selectedParentIndex].children)
                    newProduct[selectedParentIndex].children = [];

                newProduct[selectedParentIndex].isBundleExpanded = true;

                newProduct[selectedParentIndex].noItemInBundleErr = null;
                newProduct[selectedParentIndex].children.push(
                    newlyAddedChildItem
                );
            }
        });
        if (showMultipleS33ItemErrorMsg) {
            showErrorMsg(
                t('reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound')
            );
        }
        if (setOrItemNumbersFinal.length - countOfItemsRemoved > 0) {
            !showMultipleS33ItemErrorMsg &&
                showErrorMsg(
                    `${
                        setOrItemNumbersFinal.length - countOfItemsRemoved === 1
                            ? t('templates.templatesList.item')
                            : t('consignment.itemList.items')
                    } ${t(
                        'reportUsage.procedure.unidSurgery.SurgeryOrReport.addedbundle'
                    )}`,
                    !showMultipleS33ItemErrorMsg
                );
            filteredProductList = newProduct.filter(
                (item) => item !== undefined
            );

            const newArray = filteredProductList.map((item) => {
                return {
                    ...item,
                    accountOwned: item.accountOwned ? item.accountOwned : false,
                };
            });
            setFilteredProduct(newArray);
            dispatch({
                type: 'SET_ITEMS_PRICING_DONE_FLAG',
                payload: false,
            });
            setDisableDoneButton(false);
        }
    };

    const addItemsToRPBundle = (setOrItemNumbersFinal, newProduct) => {
        let filteredList = [];
        let filteredProductList = [];
        let selectedParentIndex = selectedBundleProduct.index;
        let selectedParentItem = selectedBundleProduct.cfn;
        let isS33ItemPresent = checkS33ItemPresent(
            newProduct[selectedParentIndex]?.bundleItem
        );
        let showMultipleS33ItemErrorMsg = false;
        let countOfItemsRemoved = 0;

        filteredList = newProduct?.filter(
            (item) => item.cfn === selectedParentItem
        );

        setOrItemNumbersFinal.map((itemCFN) => {
            const addedChildProduct = {
                parent: selectedBundleProduct,
                child: itemCFN,
                isBundle: checkIfValidBundleItem(itemCFN),
                isSet: false,
            };
            if (itemCFN.toUpperCase().startsWith('S33')) {
                if (isS33ItemPresent) {
                    showMultipleS33ItemErrorMsg = true;
                    countOfItemsRemoved++;
                    return;
                }
                isS33ItemPresent = true;
            }
            if (
                addedChildProduct?.child &&
                Object.keys(addedChildProduct).length > 0 &&
                filteredList
            ) {
                const newlyAddedChildItem = {
                    productCFN: addedChildProduct?.child,
                    isBundleChild: true,
                    dailyRate: '',
                    description: '',
                    salesOrg: '',
                    uom: '',
                    lotSerialNumber: '',
                    accountOwned: false,
                    isBundleFromAddItem: addedChildProduct.isBundle,
                    isSet: addedChildProduct.isSet,
                    isAdditionalCartChild: true,
                    cfn: addedChildProduct?.child,
                    id: generate_UUID(),
                    unqId: generate_UUID(),
                    isPriced: false,
                };

                if (addedChildProduct.isBundle) {
                    newlyAddedChildItem.isBundleItem = true;
                    newlyAddedChildItem.isInvalidItemMsg = t(
                        'productValidationMessages.bundleCannotBeAddedAsItemMsg'
                    );
                }

                if (!newProduct[selectedParentIndex]?.children)
                    newProduct[selectedParentIndex].children = [];

                newProduct[selectedParentIndex].isBundleExpanded = true;
                reportPaymentGridData[selectedParentIndex].noItemInBundleErr =
                    null;

                newProduct[selectedParentIndex].noItemInBundleErr = null;
                newProduct[selectedParentIndex].children.push(
                    newlyAddedChildItem
                );
                reportPaymentGridData[selectedParentIndex]?.bundleItem.push(
                    newlyAddedChildItem
                );
                setReportPaymentGridData(reportPaymentGridData);
            }
        });
        if (showMultipleS33ItemErrorMsg) {
            showErrorMsg(
                t('reportUsage.procedure.unidSurgery.SurgeryOrReport.notfound')
            );
        }
        if (setOrItemNumbersFinal.length - countOfItemsRemoved > 0) {
            !showMultipleS33ItemErrorMsg &&
                showErrorMsg(
                    `${
                        setOrItemNumbersFinal.length - countOfItemsRemoved === 1
                            ? t('templates.templatesList.item')
                            : t('consignment.itemList.items')
                    } ${t(
                        'reportUsage.procedure.unidSurgery.SurgeryOrReport.addedbundle'
                    )}`,
                    !showMultipleS33ItemErrorMsg
                );
            filteredProductList = newProduct.filter(
                (item) => item !== undefined
            );

            const newArray = filteredProductList.map((item) => {
                return {
                    ...item,
                    accountOwned: item.accountOwned ? item.accountOwned : false,
                };
            });
            setFilteredProduct(newArray);
            dispatch({
                type: 'SET_ITEMS_PRICING_DONE_FLAG',
                payload: false,
            });
            setDisableDoneButton(false);
        }
    };

    const addBulkToList = () => {
        let setOrItemNumbers = [];
        let setOrItemNumbersFinal = [];
        if (!!bulkValues && bulkValues.includes('\n')) {
            setOrItemNumbers = bulkValues
                .split('\n')
                .map((element) =>
                    element
                        .replace(/[\r\n]+/gm, '')
                        .trim()
                        .toUpperCase()
                )
                .filter((item) => item.length > 0);
            setOrItemNumbers.forEach((item) => {
                setOrItemNumbersFinal = [
                    ...setOrItemNumbersFinal,
                    ...item
                        .split(',')
                        .map((ele) => ele.trim().toUpperCase())
                        .filter((item) => item.length > 0),
                ];
            });
        } else if (bulkValues.includes(',')) {
            setOrItemNumbersFinal = bulkValues
                .split(',')
                .map((element) => element.trim().toUpperCase())
                .filter((item) => item.length > 0);
        } else if (bulkValues.length) {
            setOrItemNumbersFinal = bulkValues
                .split(',')
                .map((item) => item.trim().toUpperCase());
        } else {
            return;
        }

        if (setOrItemNumbersFinal && setOrItemNumbersFinal.length > 0) {
            var newProduct = isReportPayment
                ? [...(reportPaymentGridData || [])]
                : [...(filteredProduct || [])];
            if (isBundle) {
                isReportPayment
                    ? addItemsToRPBundle(setOrItemNumbersFinal, newProduct)
                    : addItemsToBundle(setOrItemNumbersFinal, newProduct);
            } else {
                isReportPayment
                    ? addItemsToRPList(setOrItemNumbersFinal, newProduct)
                    : addItemsToList(setOrItemNumbersFinal, newProduct);

                dispatch(setAllAccountOwned(false));
            }

            if (!isReportPayment) {
                removeAppliedSignature();
                dispatch(resetProgressBarStatus());
            }
        }
        setBulkValues('');
    };

    return (
        <TabContainer>
            <Title>{t('receiveSets.addOrPastInBulk')}</Title>
            <TextAreaContainer>
                <TextArea
                    id={`bulk-add-textarea-${isBundle ? 'bundle' : 'list'}`}
                    height={isBundle ? '160px' : editableHeight}
                    value={bulkValues}
                    onChange={(e) => onBulkAddChange(e.target.value)}
                    placeholder={t('reportUsage.bulkAddPlaceHolder')}
                ></TextArea>
            </TextAreaContainer>
            <StyledDiv>
                {`${
                    bulkValues
                        .split('\n')
                        .map((element) =>
                            element.replace(/[\r\n]+/gm, '').trim()
                        )
                        .filter((item) => item.length > 0).length
                }` >= 1 && (
                    <p
                        style={{
                            fontSize: '14px',
                            color: '#000000',
                            margin: '0',
                            fontFamily: 'AvenirNextWorld Regular',
                            opacity: '1',
                        }}
                    >
                        {`${
                            bulkValues
                                .split('\n')
                                .map((element) =>
                                    element.replace(/[\r\n]+/gm, '').trim()
                                )
                                .filter((item) => item.length > 0).length
                        } lines`}
                    </p>
                )}
            </StyledDiv>
            <ButtonsContainer>
                <Button
                    show
                    // secondary
                    variant ={ButtonStyles?.secondary}
                    width={'84px'}
                    height={'38px'}
                    margin={'0px 9px 0px 0px'}
                    clicked={copyToClipBoard}
                    // fontSize={'15px'}
                >
                    {t('receiveSets.paste')}
                </Button>
                <Button
                    show
                    // secondary
                    variant ={ButtonStyles?.secondary}
                    width={'84px'}
                    height={'38px'}
                    margin={'0px 9px 0px 0px'}
                    clicked={onClearButtonClick}
                    // fontSize={'15px'}
                >
                    {t('common.clearButton')}
                </Button>
                <Button
                    show
                    disabled={bulkValues.length < 1}
                    // primary={bulkValues.length > 0}
                    variant={bulkValues.length > 0 ? ButtonStyles?.primary : undefined}
                    width={isBundle ? '130px' : '120px'}
                    height={'38px'}
                    clicked={addBulkToList}
                    // fontSize={'15px'}
                    WhiteSpace={isBundle && 'nowrap'}
                >
                    {isBundle
                        ? t('reportUsage.addToBundleText')
                        : t('receiveSets.addTolistText')}
                </Button>
            </ButtonsContainer>
            {showDiscardPopup ? (
                <CancelAlertPopup
                    popupTitle={t(
                        'consignmentReturn.common.consignmentBillingHeader.notifications.unsavedChanges'
                    )}
                    alertMessage={t(
                        'consignmentReturn.common.consignmentBillingHeader.notifications.unsavedChabgesWillBeLost'
                    )}
                    btn1Label={t(
                        'receiveSets.ReceiveSetsLoc.AddSetsLists.discardChanges'
                    )}
                    btn2Label={t('reportUsage.common.continueEditing')}
                    btn1ClickHandler={handleDiscardChanges}
                    btn2ClickHandler={() =>
                        setPopupDetails({
                            ...popupDetails,
                            showDiscardPopup: false,
                            id: null,
                        })
                    }
                    isBundleBulkAdd={isBundle}
                />
            ) : null}
        </TabContainer>
    );
};

export default BulkAdd;
